<template>
    <AppLayoutBase>
        <template slot="drawer">
            <AppLayoutNavbarDrawer title="Mitarbeiter-Gespräche">
                <template slot="img">
                    <img src="@/assets/employee-interview-primary.svg" alt="Mitarbeiter-Gespräche"/>
                </template>
                <template slot="list">
                    <EmployeeInterviewsLayoutDrawer/>
                </template>
            </AppLayoutNavbarDrawer>
        </template>

        <template slot="main">
            <EmployeeInterviewsEmployeesContent/>
        </template>
    </AppLayoutBase>
</template>

<script>
    export default {
        name: "EmployeeInterviewsEmployees"
    }
</script>

<style scoped>

</style>